import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import BookDetailsComponent from '../../components/BookDetails/BookDetails';
import BackToTop from '../../components/BackToTop/BackToTop';

export default class BookDetails extends React.Component{

    constructor(props){
        super(props);
        window.scrollTo(0,0);
        //data={this.props.location.state}  no component BookDetails
    }

    render(){
        return(
            <Fragment>
                <Header history={this.props.history} />
                <BookDetailsComponent  history={this.props.history}/>
                <Footer history={this.props.history} />
                <BackToTop/>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/BookDetails/index.js